import * as types from '../services/commonActionType';

const commonReducer = (state = {}, action) => {

    switch (action.type) {

        case types.EXPORT_TO_CSV_REQUEST:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : true,
                lastExportRequestId: action.payload?.requestId || null,
                lastExportStatus: 'in_progress',
            };
        case types.EXPORT_TO_CSV_SUCCESS:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : false,
                lastExportRequestId: action.payload?.requestId || state.lastExportRequestId || null,
                lastExportStatus: 'success',
                lastExportCompletedAt: Date.now(),
            };
        case types.EXPORT_TO_CSV_FAILURE:
            return {
                ...state,
                isExporting: action.payload?.showLoader === false ? state.isExporting : false,
                lastExportRequestId: action.payload?.requestId || state.lastExportRequestId || null,
                lastExportStatus: 'failure',
                lastExportCompletedAt: Date.now(),
            };

        case types.DASHBOARD_DETAILS_REQUEST:
            return { ...state, isLoadingDashboard: true, };
        case types.DASHBOARD_DETAILS_SUCCESS:
            return { ...state, isLoadingDashboard: false, dashboardDetails: action.payload?.dashboardDetails };
        case types.DASHBOARD_DETAILS_FAILURE:
            return { ...state, isLoadingDashboard: false, dashboardDetails: [] };

        case types.QGENDA_TASKS_SCHEDULES_REQUEST:
            return { ...state, isLoadingDashboard: true, };
        case types.QGENDA_TASKS_SCHEDULES_SUCCESS:
            return { ...state, isLoadingDashboard: false };
        case types.QGENDA_TASKS_SCHEDULES_FAILURE:
            return { ...state, isLoadingDashboard: false };

        case types.SET_ALLOWED_MENUS:
            return { ...state, allowedMenus: action.payload?.lstAllowedMenus || [] };

        case types.UPDATE_COMMON_REDUCER:
            return { ...state, ...action.payload };
            
        case types.ASSIGNED_SITES_COUNT_SUCCESS:
            return { ...state, assignedSitesCount: action.payload || 0 };
        case types.ASSIGNED_SITES_COUNT_FAILURE:
            return { ...state, assignedSitesCount: 0 };

        case types.UNASSIGNED_SITES_COUNT_SUCCESS:
            return { ...state, unassignedSitesCount: action.payload || 0 }; 
        case types.UNASSIGNED_SITES_COUNT_FAILURE:
            return { ...state, unassignedSitesCount: 0 };

        case types.ASSIGNED_ROLES_WITH_PRACTICES_SUCCESS:
            return { ...state, assignedRolesWithPractices: action.payload?.assignedRolesWithPracticesList || [] };
        case types.ASSIGNED_ROLES_WITH_PRACTICES_FAILURE:
            return { ...state, assignedRolesWithPractices: [] };

        default:
            return state;
    }
};

export default commonReducer;